import {useEffect, useMemo, useState} from "react";
import {css} from "@panda/css";
import * as lscache from "lscache";

import {CloseIcon} from "@pg-design/icons-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";
import {PreferencesSurveySource} from "@pg-rp/common-types";
import {getRandomConsultant} from "@pg-rp/consultants";

import {HOTLINE_MODAL_CLOSED_KEY} from "../../app/constants/storage_keys";
import {RPModal} from "../../atoms/RPModal";
import {useIsRegistrationWizardFlowActive} from "../../auth/hooks/use_is_registration_wizard_flow_active";
import {openForYouModal} from "../../for_you/state/for_you_modal_slice";
import {ForYouOpenType} from "../../for_you/types/ForYouOpenType";
import {OfferType} from "../../offer/types/OfferType";
import {useAppDispatch} from "../../store/hooks";
import {gtmWeWillFindForYouOpen} from "../../tracking/google_tag_manager/gtm_event_we_will_find_for_you";
import {DELAYED_CONTACT_MODAL_MS} from "../constants/delayed_contact_modal_ms";
import {HotlineConsultantWidget} from "./HotlineConsultantWidget";

const HOTLINE_MODAL_EXPIRATION_MINUTES = 24 * 60; // 24 hours

interface IProps {
    trackingEventCategory: string;
}

export const HotlineModal = (props: IProps) => {
    const {isMobile} = useUserDevice();
    const dispatch = useAppDispatch();
    const isRegistrationWizardShown = useIsRegistrationWizardFlowActive();

    const [isOpen, setIsOpen] = useState(false);
    const consultant = useMemo(() => getRandomConsultant(), []);

    useEffect(() => {
        const wasClosed = lscache.get(HOTLINE_MODAL_CLOSED_KEY);
        if (wasClosed) {
            return;
        }

        const timer = setTimeout(() => {
            if (!isOpen) {
                setIsOpen(true);
            }
        }, DELAYED_CONTACT_MODAL_MS);

        return () => clearTimeout(timer);
    }, []);

    const handleClose = () => {
        lscache.set(HOTLINE_MODAL_CLOSED_KEY, true, HOTLINE_MODAL_EXPIRATION_MINUTES);
        setIsOpen(false);
    };

    const openForYouFlow = () => {
        gtmWeWillFindForYouOpen();
        dispatch(openForYouModal({types: [OfferType.FLAT, OfferType.HOUSE], source: PreferencesSurveySource.FOR_YOU_LANDING, openFrom: ForYouOpenType.WIDGET}));
        handleClose();
    };

    return (
        <RPModal
            isOpen={isOpen && !isRegistrationWizardShown}
            dataTestId={OFFER_TEST_IDS.OFFER_VIEW.HOTLINE_DELAYED_MODAL}
            closeButton={(onModalClose) => (
                <CloseIcon
                    size="2"
                    wrapperSize="4.8"
                    wrapperType="circle"
                    wrapperColor={isMobile ? "var(--colors-white)" : "transparent"}
                    onClick={onModalClose}
                    className={closeButtonStyle}
                    dataTestId={OFFER_TEST_IDS.OFFER_VIEW.HOTLINE_DELAYED_MODAL_CLOSE_BUTTON}
                />
            )}
            onModalClose={handleClose}
            className={phoneModalStyle}
        >
            <HotlineConsultantWidget
                variant="delayed"
                consultant={consultant}
                primaryCtaLabel="Zamów rozmowę"
                onPrimaryCtaClick={openForYouFlow}
                primaryCtaDataTestId={OFFER_TEST_IDS.OFFER_VIEW.HOTLINE_CONSULTANT_PRIMARY_CTA}
                trackingEventCategory={props.trackingEventCategory}
            />
        </RPModal>
    );
};

const phoneModalStyle = css({
    bottom: -1,
    p: 4,
    borderRadius: 2,
    overflow: "unset",
    width: "100%",

    md: {
        bottom: "unset",
        width: "60.8rem",
        maxWidth: "calc(100vw - 4.8rem)",
        borderRadius: 3
    }
});

const closeButtonStyle = css({
    cursor: "pointer",
    position: "absolute",
    top: -7,
    right: "50%",
    transform: "translate(50%, 0)",
    boxShadow: "var(--shadow-2)",
    md: {
        top: -3,
        right: -3,
        transform: "unset",
        boxShadow: "unset"
    }
});
import {useEffect, useMemo, useState} from "react";
import {css} from "@panda/css";
import * as lscache from "lscache";

import {CloseIcon} from "@pg-design/icons-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";
import {PreferencesSurveySource} from "@pg-rp/common-types";
import {getRandomConsultant} from "@pg-rp/consultants";

import {HOTLINE_MODAL_CLOSED_KEY} from "../../app/constants/storage_keys";
import {RPModal} from "../../atoms/RPModal";
import {useIsRegistrationWizardFlowActive} from "../../auth/hooks/use_is_registration_wizard_flow_active";
import {openForYouModal} from "../../for_you/state/for_you_modal_slice";
import {ForYouOpenType} from "../../for_you/types/ForYouOpenType";
import {OfferType} from "../../offer/types/OfferType";
import {useAppDispatch} from "../../store/hooks";
import {gtmWeWillFindForYouOpen} from "../../tracking/google_tag_manager/gtm_event_we_will_find_for_you";
import {DELAYED_CONTACT_MODAL_MS} from "../constants/delayed_contact_modal_ms";
import {HotlineConsultantWidget} from "./HotlineConsultantWidget";

const HOTLINE_MODAL_EXPIRATION_MINUTES = 24 * 60; // 24 hours

interface IProps {
    trackingEventCategory: string;
}

export const HotlineModal = (props: IProps) => {
    const {isMobile} = useUserDevice();
    const dispatch = useAppDispatch();
    const isRegistrationWizardShown = useIsRegistrationWizardFlowActive();

    const [isOpen, setIsOpen] = useState(false);
    const consultant = useMemo(() => getRandomConsultant(), []);

    useEffect(() => {
        const wasClosed = lscache.get(HOTLINE_MODAL_CLOSED_KEY);
        if (wasClosed) {
            return;
        }

        const timer = setTimeout(() => {
            if (!isOpen) {
                setIsOpen(true);
            }
        }, DELAYED_CONTACT_MODAL_MS);

        return () => clearTimeout(timer);
    }, []);

    const handleClose = () => {
        lscache.set(HOTLINE_MODAL_CLOSED_KEY, true, HOTLINE_MODAL_EXPIRATION_MINUTES);
        setIsOpen(false);
    };

    const openForYouFlow = () => {
        gtmWeWillFindForYouOpen();
        dispatch(openForYouModal({types: [OfferType.FLAT, OfferType.HOUSE], source: PreferencesSurveySource.FOR_YOU_LANDING, openFrom: ForYouOpenType.WIDGET}));
        handleClose();
    };

    return (
        <RPModal
            isOpen={isOpen && !isRegistrationWizardShown}
            dataTestId={OFFER_TEST_IDS.OFFER_VIEW.HOTLINE_DELAYED_MODAL}
            closeButton={(onModalClose) => (
                <CloseIcon
                    size="2"
                    wrapperSize="4.8"
                    wrapperType="circle"
                    wrapperColor={isMobile ? "var(--colors-white)" : "transparent"}
                    onClick={onModalClose}
                    className={closeButtonStyle}
                    dataTestId={OFFER_TEST_IDS.OFFER_VIEW.HOTLINE_DELAYED_MODAL_CLOSE_BUTTON}
                />
            )}
            onModalClose={handleClose}
            className={phoneModalStyle}
        >
            <HotlineConsultantWidget
                variant="delayed"
                consultant={consultant}
                primaryCtaLabel="Zamów rozmowę"
                onPrimaryCtaClick={openForYouFlow}
                primaryCtaDataTestId={OFFER_TEST_IDS.OFFER_VIEW.HOTLINE_CONSULTANT_PRIMARY_CTA}
                trackingEventCategory={props.trackingEventCategory}
            />
        </RPModal>
    );
};

const phoneModalStyle = css({
    bottom: -1,
    p: 4,
    borderRadius: 2,
    overflow: "unset",
    width: "100%",

    md: {
        bottom: "unset",
        width: "60.8rem",
        maxWidth: "calc(100vw - 4.8rem)",
        borderRadius: 3
    }
});

const closeButtonStyle = css({
    cursor: "pointer",
    position: "absolute",
    top: -7,
    right: "50%",
    transform: "translate(50%, 0)",
    boxShadow: "var(--shadow-2)",
    md: {
        top: -3,
        right: -3,
        transform: "unset",
        boxShadow: "unset"
    }
});
